import { render, staticRenderFns } from "./App.vue?vue&type=template&id=37e14471&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=37e14471&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e14471",
  null
  
)

export default component.exports